<template>
<div>
    <div>
        <vs-button size="large" color="danger" type="flat" icon-pack="feather" @click="notificationDeletePopup" icon="icon-trash"></vs-button>
    </div>
    <vs-popup  title="Delete Notification" :active.sync="deletepopupflag">
        <vs-row>
          <span>Are you sure to delete this notification?</span>
          
        </vs-row>
        <vs-row vs-type="flex" vs-justify="flex-end" class="mt-4">
          <vs-button @click="deleteNotification" color="primary" type="filled" class="mr-2 vs-con-loading__container">Confirm</vs-button>
          <vs-button @click="deletepopupflag=!deletepopupflag" type="border">Cancel</vs-button>
        </vs-row>
      </vs-popup>
      </div>
</template>

<script>
import { notificationDelete } from '@/api/notification.js'
import { mapActions } from 'vuex'
export default {
  name: 'Action',
  data () {
    return {
      deletepopupflag: false
    }
  },
  
  methods: {
    ...mapActions(
      ['SET_DELETE_ID']
    ),
    notificationDeletePopup () {
      this.deletepopupflag = true
      
    },
    deleteNotification () { 
      const payload = {
        customer_id: localStorage.getItem('customer_id'),
        notification: [this.params.data.notification_id]
      }
      
      
      notificationDelete(payload)
        .then((res) => {
          
          this.SET_DELETE_ID(this.params.data.notification_id)
          this.deletepopupflag = false
          this.$vs.notify({
            title: 'Success',
            text: 'Notification Deleted Successfully',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
        })
        .catch((e) => {
          
          this.$vs.notify({
            title: 'Warning',
            text: 'Something Went Wrong',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        })
    }
    
  }
}
</script>
